

import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core'; // useful for typechecking
import listPlugin from '@fullcalendar/list';
import { FullCalendarModule } from '@fullcalendar/angular'; // for FullCalendar!
import timeGridPlugin from '@fullcalendar/timegrid';
import { bmxurl } from 'src/globals';
import { booking_returndata } from 'src/types/booking_returndata';
import { cCalendarEvent } from 'src/types/calendarEvent';
import { packagerule_returndata } from 'src/types/packagerule_returndata';
import { venue_returndata } from 'src/types/venue_returndata';
import { GlobalService } from '../_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-scheduledsessioncalendar',
  templateUrl: './scheduledsessioncalendar.component.html',
  styleUrls: ['./scheduledsessioncalendar.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ScheduledSessioncalendarComponent implements OnInit {

  ListScheduledSessions: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  Events: any = [];
  jsonEvents: any;
  Venue: any;
  venueStartTime: any;
  venueEndTime: any;
  BookingResources: any[] = [];
  ListResources: any[];


  calendarOptions: CalendarOptions = {
    initialView: 'timeGridWeek',
    plugins: [timeGridPlugin, listPlugin, ],
    events: this.Events,
    slotMinTime: '09:00:00',
    slotMaxTime: '21:00:00',
    expandRows: true,
    locale: 'en-GB',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'timeGridWeek,timeGridDay,listDay'
    },
    buttonText: {
      timeGridWeek: '  Week View  ',
      timeGridDay: '  Day View  ',
      listDay: '  List View  ',
      today: '  Today  '
    },
    editable: false,
    eventClick: (arg) => this.onEventClick(arg)
  };

  changeDate(){
  }

  changeView(view: string) {

    this.calendarOptions = { ...this.calendarOptions }; 
    this.calendarOptions.initialView = view;

  }

  constructor(private http: HttpClient, private globalService: GlobalService, private router: Router, private route: ActivatedRoute) { }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  addmins(date: Date, mins: number): Date {
    const newDate = new Date(date.getTime());
    newDate.setMinutes(newDate.getMinutes() + mins);
    return newDate;
  }

  onEventClick(arg: any) {
    let startDate = new Date(arg.event.start);
    let dateDate = startDate.getDate();
    let monthDate = startDate.getMonth() + 1; // Months are zero-based
    let yearDate = startDate.getFullYear();
    let hoursDate = startDate.getHours();
    let minutesDate = startDate.getMinutes();
    let formattedDate = (dateDate < 10 ? '0' + dateDate : dateDate).toString() + (monthDate < 10 ? '0' + monthDate : monthDate).toString() + yearDate + (hoursDate < 10 ? '0' + hoursDate : hoursDate) + (minutesDate < 10 ? '0' + minutesDate : minutesDate);

    //The marker tells the register where it was opened from, so its back button can offer
    //the calendar rather than the session list.
    this.router.navigate(["/scheduledsessionregister", arg.event.extendedProps.eventid, formattedDate], { queryParams: { from: "calendar" } });
  }

  ngOnInit(): void {

      this.route.params.subscribe(params => {
        const dateParam = params['date'];
        if (dateParam) {
          const day = parseInt(dateParam.substring(0, 2), 10);
          const month = parseInt(dateParam.substring(2, 4), 10) - 1;
          const year = parseInt(dateParam.substring(4, 8), 10);
          this.calendarOptions.initialDate = new Date(year, month, day).toISOString();
        }
      });

      this.calendarOptions.eventContent = (arg: any) =>
      {   
          let timeText = document.createElement('div')
            timeText.className = "fc-event-time";
            timeText.textContent = arg.timeText;

          let additionalText = document.createElement('i')
            additionalText.className = "fc-event-title";
            additionalText.textContent = arg.event.title;

          if(arg.event.extendedProps.duration) {
            additionalText.textContent += " (" + arg.event.extendedProps.duration + " minutes)";
          } 

          let arrayOfDomNodes = [ timeText, additionalText ]
          return { domNodes: arrayOfDomNodes }
        
      }

      this.http.get(bmxurl + "scheduledsessionregisterlist/" + this.VenueID).subscribe(response => {
      this.ListScheduledSessions = (response as any).data;
      this.Events = []; 

      this.ListScheduledSessions.forEach(element => {
        let newEvent: any;
        let startdate = new Date(element.startdate);
        let enddate = this.addmins(startdate, element.duration || 0);

        newEvent = {
          eventid: element.scheduledsessionid,
          end: enddate.toISOString(),
          start: startdate.toISOString(),
          backgroundColor: element.colour || "#a07404ff",
          title: element.name,
          //numberofweeks: element.numberofweeks || 1,
          duration: element.duration || 0,
        }

        this.Events.push(newEvent);
      });
      }, error => {
        console.error("Error fetching Scheduled Session:", error);
      });




  }

}
 
